<div class="arrow-wrapper" [ngClass]="[direction, size]">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 14 20" fill="none" >
    <path d="M2 10 H14 M10 6 L14 10 L10 14" [attr.stroke]="color === 'positive' ? '#6EC68A' : '#EE7D79'" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
  </svg>
</div>
